import React, { useEffect, createElement } from 'react';
import { BonusPage } from './pages/BonusPage';
import { PurchaseToast } from './components/PurchaseToast';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    window.fbq('init', '940393615338485');
    window.fbq('track', 'PageView');
  }, []);
  return <>
      <BonusPage data-id="element-0" />
      <PurchaseToast data-id="element-1" />
    </>;
}